module.exports = __webpack_public_path__ + "static/media/13n.dc58368f.svg";